/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Try_Attachment_LabelInputs */

const en_mcp_try_attachment_label = /** @type {(inputs: Mcp_Try_Attachment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachment (web)`)
};

const es_mcp_try_attachment_label = /** @type {(inputs: Mcp_Try_Attachment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjunto (web)`)
};

/**
* | output |
* | --- |
* | "Attachment (web)" |
*
* @param {Mcp_Try_Attachment_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_try_attachment_label = /** @type {((inputs?: Mcp_Try_Attachment_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Try_Attachment_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_try_attachment_label(inputs)
	return en_mcp_try_attachment_label(inputs)
});